import type { JobSummaryContentV2 } from '@xing-com/crate-common-graphql-types';
import type { NwtTrackingProps } from '@xing-com/crate-jobs-tracking';

import { JobsXingletWrapper } from '../../../jobs-xinglet';

import { AiJobSummarySkeleton } from './ai-job-summary-skeleton';

type AiJobSummaryBaseProps = {
  summary?: JobSummaryContentV2;
  jobTitle?: string;
  companyName?: string;
  companyLogo?: string;
  isSuperMatch?: boolean;
  nwtTrackingProps?: Partial<NwtTrackingProps>;
};

export type AiJobSummaryProps =
  | (AiJobSummaryBaseProps & {
      variant?: 'default';
      jobGlobalId: string;
    })
  | (AiJobSummaryBaseProps & {
      variant: 'card' | 'aside';
    });

export const AiJobSummary = JobsXingletWrapper<AiJobSummaryProps>(
  '@xing-com/crate-jobs-domain-job-details-ai-job-summary',
  <AiJobSummarySkeleton />
);
